import { OnBehalfOfOrganization } from '../features/job-seeker-on-behalf-of-organization/types';
import { OnBehalfOfOrganizationAdmin } from '../features/job-seeker-on-behalf-of-organization-admin/types';
import { JobSeeker, JobSeekerCommunityAdminRole } from '../features/job-seeker-auth';

export const getProgramLeadInCommunitiesSelectList = (jobSeeker: JobSeeker | null): OnBehalfOfOrganization[] => {
  if (jobSeeker) {
    const programLeads = jobSeeker.verifiedOrganizations?.map(org => {
      const communityRole = jobSeeker.cumulativeRoles?.communitiesRoles?.[org.id];
      return communityRole?.leadPrograms?.length ? {
        text: org.name,
        value: org.id,
        communityAdminRole: communityRole?.communityAdminRole === JobSeekerCommunityAdminRole.FullAdmin || communityRole?.communityAdminRole === JobSeekerCommunityAdminRole.ViewOnlyAdmin ? communityRole.communityAdminRole : JobSeekerCommunityAdminRole.None,
        leadPrograms: communityRole.leadPrograms ?? [],
        logo: org.logo,
      } : null;
    }).filter(Boolean) as OnBehalfOfOrganization[] ?? [];
    return programLeads;
  }
  return [];
};

export const checkIsLeadInProgram = (jobSeeker: JobSeeker | null, IsLeadInProgramId?: string): boolean => {
  if (!IsLeadInProgramId) return false;

  const programLeadInCommunitiesSelectList = getProgramLeadInCommunitiesSelectList(jobSeeker);
  return programLeadInCommunitiesSelectList.some(item => Array.isArray(item.leadPrograms) && item.leadPrograms.includes(IsLeadInProgramId));
};

export const checkIsAtLeastOneProgramLead = (jobSeeker: JobSeeker | null): boolean => {
  const leadProgramInCommunities = getProgramLeadInCommunitiesSelectList(jobSeeker);
  return leadProgramInCommunities.length > 0;
};

export const getAdminInCommunitiesSelectList = (jobSeeker?: JobSeeker): OnBehalfOfOrganizationAdmin[] => {
  if (jobSeeker) {
    const adminInCommunities = jobSeeker.verifiedOrganizations?.filter(org => jobSeeker.cumulativeRoles?.adminCommunityIds?.includes(org.id))
      .map(org => {
        const communityRole = jobSeeker.cumulativeRoles?.communitiesRoles?.[org.id];
        return {
          text: org.name,
          value: org.id,
          communityAdminRole: communityRole?.communityAdminRole === JobSeekerCommunityAdminRole.FullAdmin || communityRole?.communityAdminRole === JobSeekerCommunityAdminRole.ViewOnlyAdmin ? communityRole.communityAdminRole : JobSeekerCommunityAdminRole.None,
          logo: org.logo,
        };
      }) ?? [];
    return adminInCommunities;
  }
  return [];
};

export const getAdminRoleInCommunity = (organizationAdminId: string, adminCommunities: OnBehalfOfOrganizationAdmin[]): JobSeekerCommunityAdminRole | undefined => {
  const community = adminCommunities.find(c => c.value === organizationAdminId);
  return community?.communityAdminRole;
};

export const getIsFullAdminInCommunitiesSelectList = (jobSeeker?: JobSeeker): OnBehalfOfOrganizationAdmin[] => {
  const adminInCommunities = getAdminInCommunitiesSelectList(jobSeeker);
  return adminInCommunities.filter(item => item.communityAdminRole === JobSeekerCommunityAdminRole.FullAdmin);
};

export const getIsViewOnlyAdminInCommunitiesSelectList = (jobSeeker?: JobSeeker): OnBehalfOfOrganizationAdmin[] => {
  const adminInCommunities = getAdminInCommunitiesSelectList(jobSeeker);
  return adminInCommunities.filter(item => item.communityAdminRole === JobSeekerCommunityAdminRole.ViewOnlyAdmin);
};

export const checkIsCommunityAdmin = (jobSeeker: JobSeeker | null, organizationAdminId: string): boolean => {
  if (!jobSeeker || !organizationAdminId) return false;
  const adminInCommunities = getAdminInCommunitiesSelectList(jobSeeker);
  return adminInCommunities.some(item => item.value === organizationAdminId);
};

export const checkIsCommunityFullAdmin = (jobSeeker: JobSeeker | null, organizationAdminId: string): boolean => {
  if (!jobSeeker || !organizationAdminId) return false;
  const fullAdminInCommunities = getIsFullAdminInCommunitiesSelectList(jobSeeker);
  return fullAdminInCommunities.some(item => item.value === organizationAdminId);
};

export const checkIsCommunityViewOnlyAdmin = (jobSeeker: JobSeeker | null, organizationAdminId: string): boolean => {
  if (!jobSeeker || !organizationAdminId) return false;
  const viewOnlyAdminInCommunities = getIsViewOnlyAdminInCommunitiesSelectList(jobSeeker);
  return viewOnlyAdminInCommunities.some(item => item.value === organizationAdminId);
};

export const checkIsAtLeastOneCommunityAdmin = (jobSeeker: JobSeeker | null): boolean => {
  if (!jobSeeker) return false;
  const adminInCommunities = getAdminInCommunitiesSelectList(jobSeeker);
  return adminInCommunities.length > 0;
};

export const checkIsAtLeastOneCommunityFullAdmin = (jobSeeker: JobSeeker | null): boolean => {
  if (!jobSeeker) return false;
  const fullAdminInCommunities = getIsFullAdminInCommunitiesSelectList(jobSeeker);
  return fullAdminInCommunities.length > 0;
};

export const checkIsAtLeastOneCommunityViewOnlyAdmin = (jobSeeker: JobSeeker | null): boolean => {
  if (!jobSeeker) return false;
  const viewOnlyAdminInCommunities = getIsViewOnlyAdminInCommunitiesSelectList(jobSeeker);
  return viewOnlyAdminInCommunities.length > 0;
};